import axios from 'axios';

async function ValidarUsuario(prmUsuario: string, prmClave: string) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/validar_usuario"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "login": {
                "email": prmUsuario,
                "password": prmClave
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ValidarUsuario;